export var PROGRESS_BAR_SIZE = {
  SMALL: 'small'
};